var _ = require('underscore/underscore');

module.exports = function (env) {

    env.addGlobal('static', function (file) {
        return '/static/' + file;
    }, true);

    env.addGlobal('hasMod', function (mods, mod) {
        return _.indexOf(mods, mod) !== -1;
    });
};



//////////////////
// WEBPACK FOOTER
// ./nunjucks.config.js
// module id = 210
// module chunks = 0